import * as React from 'react';

const BoogieSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="boogie_svg__eds-icon--boogie_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="boogie_svg__eds-icon--boogie_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 9.8v5.3l-2-1.7V9.8c0-.8.6-1 1-1s1 .2 1 1zm4 4v-2l-3.5-3.3c-.4-.4-.9-.7-1.5-.7-.7 0-1.3.3-1.7.9L8 6.5V4.2H7v2.5l3 2.8v4.2l5 4.3v4.1h1v-4.6l-2-1.7v-5.7l2 1.8v1.7h1z"
        />
        <path
            className="boogie_svg__eds-icon--boogie_leg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.347 21.244l3.355-5.332.847.532-3.355 5.333z"
        />
        <path
            className="boogie_svg__eds-icon--boogie_head"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zm0 4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
        />
    </svg>
);

BoogieSvg.displayName = 'BoogieSvg';
export default BoogieSvg;
